const conutryarr =  [
  {'sty':'title','content':'Africa'},
  {'sty':'item','content':'South Africa',src:'SOUTHAFRICA',money:'ZAR'},
  {'sty':'title','content':'America'},
  {'sty':'item','content':'United States',src:'usa',money:'USD'},
  {'sty':'title','content':'Asia'},
  {'sty':'item','content':'Hong Kong, China',src:'HONGKONG',money:'HKD'},
  {'sty':'item','content':'Japan',src:'japan',money:'JPY'},
  {'sty':'item','content':'Korea',src:'korea',money:'KRW'},
  {'sty':'item','content':'Singapore',src:'SINGAPORE',money:'SGD'},
  {'sty':'item','content':'Saudi Arabia',src:'st',money:'SAR'},
  {'sty':'item','content':'Iraq',src:'ylk',money:'IQD'},
  {'sty':'item','content':'Taiwan, China',money:'TWD'},
  {'sty':'item','content':'Thailand',src:'THAILAND',money:'THB'},
  {'sty':'item','content':'United Emirates',src:'UNITEDEMIRATES',money:'AED'},
  {'sty':'title','content':'Europe'},
  {'sty':'item','content':'Germany',src:'g',money:'EUR'},
  {'sty':'item','content':'Portugal',src:'pty',money:'EUR'},
  {'sty':'item','content':'Russia',src:'rus',money:'RUB'},
  {'sty':'item','content':'Spain',src:'xb',money:'EUR'},
  {'sty':'item','content':'Switzerland',src:'SWITZERLAND',money:'CHF'},
  {'sty':'item','content':'United Kingdom',src:'en',money:'GBP'},
  {'sty':'title','content':'Oceania'},
  {'sty':'item','content':'Australia',src:'AUSTRALIA',money:'AUD'},
];
export default conutryarr;



// WEBPACK FOOTER //
// ./src/components/common/country.js